import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/PaymentTable.css";

const PaymentTable = ({ payments }) => {

    const navigate = useNavigate();

    return (
        <div className="payment-table-container">

            <table className="payment-table">

                <thead>

                    <tr>
                        <th>Payment</th>
                        <th>Order</th>
                        <th>Customer</th>
                        <th>Provider</th>
                        <th>Method</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Settlement</th>
                        <th>Action</th>
                    </tr>

                </thead>

                <tbody>

                    {payments.map((payment) => (

                        <tr key={payment._id}>

                            <td>{payment.paymentNumber}</td>

                            <td>{payment.orderNumber}</td>

                            <td>{payment.customerSnapshot?.name}</td>

                            <td>{payment.providerSnapshot?.businessName}</td>

                            <td>{payment.payment?.method}</td>

                            <td>₹{payment.pricing?.grandTotal}</td>

                            <td>{payment.payment?.status}</td>

                            <td>{payment.settlement?.status}</td>

                            <td>

                                <button
                                    className="view-btn"
                                    onClick={() =>
                                        navigate(`/admin/payments/${payment._id}`)
                                    }
                                >
                                    View
                                </button>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>
    );
};

export default PaymentTable;